import React, { useState, useEffect, useContext } from "react";
import {
  Label,
  Form,
  FormGroup,
  Row,
  Col,
  Input,
  InputGroup,
} from "reactstrap";
import { useController, useForm } from "react-hook-form";
import { getUserDetails, showAlert } from "../../Services/Shared.service";
import { getTaxGroupList } from "../../Services/Packages.service";
import { ArrowDown, ArrowUp } from "react-feather";
import { CommonModal } from "../../AbstractElements";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import {
  createCorporateClient,
  getCorporateClient,
  updateCorporateClient,
} from "../../Services/CorporateClient.service";
import SharedDataContext from "../../_helper/SharedData";
import { getCarTypes } from "../../Services/Shared.service";
import Select from "react-select";
function CorprateForms({
  cityData,
  editId,
  setCorprateClient,
  setPackId,
  handleBackCorp,
  setCorpCreate,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isAdvanced, setIsAdvanced] = useState(false);
  const [taxData, setTaxData] = useState([]);
  const [corporateClientObj, setCorporateClientObj] = useState({});
  const { mix_background_layout } = useContext(CustomizerContext);
  const [corprate, setCorprate] = useState({});

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      isMegaCabsCompany: false,
      serviceCity: "",
      companyName: "",
      panNo: "",
      serviceTaxNo: "",
      contactPerson: "",
      mobile: "",
      email: "",
      addressLine: "",
      city: "",
      state: "",
      pincode: "",
      fax: "",
      billingAddress: "",
      billingCity: "",
      billingState: "",
      billingPincode: "",
      billingContactPerson: "",
      billingContactMobile: "",
      discountValue: "",
      discountType: "",
      baseFareTax: "",
      serviceTax: "",
      isAirportClient: null,
      airportCharge: "",
      a2c: false,
      c2a: false,
      isWalletEnabled: true,
    },
  });

  const { tabValue, setTabValue, corpRefresh, setCorpRefresh } =
    useContext(SharedDataContext);
  const { overallTax } = watch();

  const [combinedTax, setCombinedTax] = useState([]);
  const [selectedTax, setSelectedTax] = useState({});

  console.log("combinedTax", combinedTax);

  useEffect(() => {
    getTaxGroupList().then((result) => {
      if (result.status == 200) {
        const data = result.data.map((element) => {
          return {
            value: element,
            label: element.name,
          };
        });

        setCombinedTax(generateTaxCombinationsForSelectBox(result.data));
      }
    });
  }, []);

  const serviceCityField = useController({
    name: "serviceCity",
    control,
    rules: {
      required: {
        value: true,
        message: "Service City is Required",
      },
    },
  }).field;

  const handleServiceCitySelectChange = (data) => {
    console.log("city data", cityData);
    serviceCityField.onChange(data.value);
  };

  const isMegaCabsCompanyField = useController({
    name: "isMegaCabsCompany",
    control,
  }).field;

  const isWalletEnabledField = useController({
    name: "isWalletEnabled",
    control,
  }).field;

  const isAirportClientField = useController({
    name: "isAirportClient",
    control,
    rules: {
      validate: (value) => {
        // Check if value is null or undefined (not selected)
        // Both true and false are valid selections
        if (value === null || value === undefined) {
          return "Please select any one of the options";
        }
        return true;
      }
  },
  }).field;

  const a2cField = useController({
    name: "a2c",
    control,
  }).field;

  const c2aField = useController({
    name: "c2a",
    control,
  }).field;

  const mobileField = useController({
    name: "mobile",
    control,
    rules: {
      required: {
        value: true,
        message: "Mobile Number is Required",
      },
    },
  }).field;

  const billingMobileField = useController({
    name: "billingContactMobile",
    control,
  }).field;

  const discountValueField = useController({
    name: "discountValue",
    control,
  }).field;

  const airportChargeField = useController({
    name: "airportCharge",
    control,
  }).field;

  const baseFareTaxField = useController({
    name: "baseFareTax",
    control,
    rules: {
      required: {
        value: true,
        message: "Base Fare Tax is Required",
      },
    },
  }).field;

  const handleBaseFareTax = (data) => {
    console.log("baseFareTaxField", data.value);
    baseFareTaxField.onChange(data.value);
  };

  const serviceTaxField = useController({
    name: "serviceTax",
    control,
    rules: {
      required: {
        value: true,
        message: "Tax is Required",
      },
    },
  }).field;

  const handleServiceFareTax = (data) => {
    serviceTaxField.onChange(data.value);
  };

  useEffect(() => {
    if (editId) {
      getCorporateClient(editId)
        .then((resp) => {
          let corporateClientObj = resp.data;
          setCorporateClientObj(corporateClientObj);
          const serviceCity = cityData.find((element) => {
            return element?.value?.id === corporateClientObj?.serviceCityId;
          });
          console.log("service city", serviceCity);
          reset({
            isMegaCabsCompany: corporateClientObj?.isMegaCabsCompany
              ? true
              : false,
            serviceCity: serviceCity?.value?.id ? serviceCity?.value : "",
            companyName: corporateClientObj?.companyName
              ? corporateClientObj.companyName
              : "",
            panNo: corporateClientObj?.panNo ? corporateClientObj.panNo : "",
            serviceTaxNo: corporateClientObj?.serviceTaxNo
              ? corporateClientObj.serviceTaxNo
              : "",
            contactPerson: corporateClientObj?.contactPerson
              ? corporateClientObj.contactPerson
              : "",
            mobile: corporateClientObj?.mobile ? corporateClientObj.mobile : "",
            email: corporateClientObj?.email ? corporateClientObj.email : "",
            addressLine: corporateClientObj?.addressLine
              ? corporateClientObj.addressLine
              : "",
            city: corporateClientObj?.city ? corporateClientObj.city : "",
            state: corporateClientObj?.state ? corporateClientObj.state : "",
            pincode: corporateClientObj?.pincode
              ? corporateClientObj.pincode
              : "",
            fax: corporateClientObj?.fax ? corporateClientObj.fax : "",
            billingAddress: corporateClientObj?.billingAddress
              ? corporateClientObj.billingAddress
              : "",
            billingCity: corporateClientObj?.billingCity
              ? corporateClientObj.billingCity
              : "",
            billingState: corporateClientObj?.billingState
              ? corporateClientObj.billingState
              : "",
            billingPincode: corporateClientObj?.billingPincode
              ? corporateClientObj.billingPincode
              : "",
            billingContactPerson: corporateClientObj?.billingContactPerson
              ? corporateClientObj.billingContactPerson
              : "",
            billingContactMobile: corporateClientObj?.billingContactMobile
              ? corporateClientObj.billingContactMobile
              : "",
            discountValue: corporateClientObj?.discountValue
              ? corporateClientObj.discountValue
              : "",
            discountType: corporateClientObj?.discountType
              ? corporateClientObj.discountType
              : "",
            baseFareTax: corporateClientObj?.baseFareTaxId
              ? { id: corporateClientObj?.baseFareTaxId }
              : "",
            serviceTax: corporateClientObj?.serviceTaxId
              ? { id: corporateClientObj?.serviceTaxId }
              : "",
            // taxField:corporateClientObj?.baseFareTaxId && corporateClientObj?.serviceTaxId ? findOption(corporateClientObj.baseFareTaxId,corporateClientObj.serviceTaxId):"",
            isAirportClient: corporateClientObj?.isAirportClient ? true : false,
            airportCharge: corporateClientObj?.airportCharge
              ? corporateClientObj.airportCharge
              : "",
            a2c: corporateClientObj?.a2c ? true : false,
            c2a: corporateClientObj?.c2a ? true : false,
            isWalletEnabled: corporateClientObj?.isWalletEnabled ? true : false,
            overallTax: combinedTax.find(
              (item) =>
                item.value.baseTax.taxGroupId === corporateClientObj.baseFareTaxId &&  
                item.value.serviceTax.taxGroupId === corporateClientObj.serviceTaxId 
            ),
          });

          setSelectedTax(
            findOption(
              corporateClientObj.baseFareTaxId,
              corporateClientObj.serviceTaxId
            )
          );
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    }
  }, [editId]);

  // useEffect(() => {
  //   if (!!combinedTax && !!corporateClientObj) {
  //     setValue(
  //       "overallTax",
  //       combinedTax.find(
  //         (item) =>
  //           item.value.baseTax.id === corporateClientObj.baseFareTaxId &&
  //           item.value.serviceTax.id === corporateClientObj.serviceTaxId
  //       )
  //     );
  //   }
  // }, [combinedTax,corporateClientObj]);
  useEffect(() => {
  if (corporateClientObj && corporateClientObj.baseFareTaxId && corporateClientObj.serviceTaxId) {
    const matchedTax = combinedTax.find(
      (item) =>
        item.value.baseTax.taxGroupId === corporateClientObj.baseFareTaxId &&
        item.value.serviceTax.taxGroupId === corporateClientObj.serviceTaxId
    );
    setValue("overallTax", matchedTax);
    setValue("baseFareTax", matchedTax?.value.baseTax);
    setValue("serviceTax", matchedTax?.value.serviceTax);
  } else {
    // No corporate client → reset to placeholder
    setValue("overallTax", null);
  }
}, [corporateClientObj, combinedTax, setValue]);


  const values = getValues();
  const onFormSubmit = (formValues) => {
    const userDetails = getUserDetails();
    setIsSubmitting(true);
    const body = {
      sapGlCode: null,
      isMegaCabsCompany: formValues.isMegaCabsCompany ? true : false,
      companyName: formValues.companyName ? formValues.companyName : null,
      companyLogo: null,
      cinNo: null,
      panNo: formValues.panNo ? formValues.panNo : null,
      serviceTaxNo: formValues.serviceTaxNo ? formValues.serviceTaxNo : null,
      contactPerson: formValues.contactPerson ? formValues.contactPerson : null,
      mobile: formValues.mobile ? formValues.mobile : null,
      email: formValues.email ? formValues.email : null,
      addressLine: formValues.addressLine ? formValues.addressLine : null,
      city: formValues.city ? formValues.city : null,
      state: formValues.state ? formValues.state : null,
      pincode: formValues.pincode ? formValues.pincode : null,
      phone1: null,
      phone2: null,
      fax: formValues.fax ? formValues.fax : null,
      billingAddress: formValues.billingAddress
        ? formValues.billingAddress
        : null,
      billingCity: formValues.billingCity ? formValues.billingCity : null,
      billingState: formValues.billingState ? formValues.billingState : null,
      billingPincode: formValues.billingPincode
        ? formValues.billingPincode
        : null,
      billingContactPerson: formValues.billingContactPerson
        ? formValues.billingContactPerson
        : null,
      billingContactMobile: formValues.billingContactMobile
        ? formValues.billingContactMobile
        : null,
      createdById: userDetails.userId,
      createdViaType: null,
      deletedOn: null,
      isDeleted: false,
      deletedById: null,
      serviceCityId: formValues.serviceCity?.id
        ? formValues.serviceCity.id
        : null,
      discountValue: formValues.discountValue ? formValues.discountValue : null,
      discountType: formValues.discountType ? formValues.discountType : null,
      baseFareTaxId: formValues.baseFareTax?.taxGroupId
        ? formValues.baseFareTax.taxGroupId
        : null,
      serviceTaxId: formValues.serviceTax?.taxGroupId ? formValues.serviceTax.taxGroupId : null,

      isAirportClient: formValues.isAirportClient ? true : false,
      lutNo: null,
      serviceDescription: formValues.serviceCity?.serviceDescription
        ? formValues.serviceCity.serviceDescription
        : null,
      sacCode: formValues.serviceCity?.sacCode
        ? formValues.serviceCity.sacCode
        : null,
      isSendSms: true,
      isSendMail: null,
      isStopInvoice: null,
      a2c: formValues.a2c ? true : false,
      c2a: formValues.c2a ? true : false,
      airportCharge: formValues.airportCharge
        ? Number(formValues.airportCharge)
        : null,
      isWalletEnabled: true,
    };
    if (corporateClientObj?.id) {
      body["id"] = corporateClientObj?.id;
      updateCorporateClient(body)
        .then((resp) => {
          reset({
            isMegaCabsCompany: false,
            serviceCity: "",
            companyName: "",
            panNo: "",
            serviceTaxNo: "",
            contactPerson: "",
            mobile: "",
            email: "",
            addressLine: "",
            city: "",
            state: "",
            pincode: "",
            fax: "",
            billingAddress: "",
            billingCity: "",
            billingState: "",
            billingPincode: "",
            billingContactPerson: "",
            billingContactMobile: "",
            discountValue: "",
            discountType: "",
            baseFareTax: "",
            serviceTax: "",
            isAirportClient: false,
            airportCharge: "",
            a2c: false,
            c2a: false,
            isWalletEnabled: true,
          });
          showAlert("success", "Corporate Client Updated Successfully");
          // fetchTableData();
          setIsSubmitting(false);
          setCorprate(resp.data);
          setCorprateClient(resp.data);       
          // setCorpCreate(resp.data)
          setTabValue(1);
          // setIsOpen(false)
          setCorpRefresh((prev) => !prev);
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
          setIsSubmitting(false);
        });
    } else {
      createCorporateClient(body)
        .then((resp) => {
          reset({
            isMegaCabsCompany: false,
            serviceCity: "",
            companyName: "",
            panNo: "",
            serviceTaxNo: "",
            contactPerson: "",
            mobile: "",
            email: "",
            addressLine: "",
            city: "",
            state: "",
            pincode: "",
            fax: "",
            billingAddress: "",
            billingCity: "",
            billingState: "",
            billingPincode: "",
            billingContactPerson: "",
            billingContactMobile: "",
            discountValue: "",
            discountType: "",
            baseFareTax: "",
            serviceTax: "",
            isAirportClient: false,
            airportCharge: "",
            a2c: false,
            c2a: false,
            isWalletEnabled: true,
          });
          showAlert("success", "Corporate Client Created Successfully");
          // fetchTableData();
          setCorprate(resp.data);
          setCorprateClient(resp.data);
          // setCorpCreate(resp.data)
          console.log("corprate is ", corprate);
          setIsSubmitting(false);
          setTabValue(1);
          // setIsOpen(false)
          setCorpRefresh((prev) => !prev);   
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
          setIsSubmitting(false);
        });
    }
  };

  const handleAirportClientChange = () => {
    setValue("isAirportClient", true);
    setValue("a2c", true);
    setValue("c2a", false);
  };

  const handleCityClientChange = () => {
    setValue("isAirportClient", false);
    setValue("a2c", false);
    setValue("c2a", true);
  };

  function generateTaxCombinationsForSelectBox(taxData) {
    // const combinations = [];

    // taxData.forEach((baseTax) => {
    //   console.log("baseTax", baseTax);
    //   taxData.forEach((serviceTax) => {
    //     console.log("serviceTax", serviceTax);
    //     const label = `Base ${
    //       baseTax.value.taxPercentage === "5%" ? "5%" : "0%"
    //     } Service ${serviceTax.value.taxPercentage === "18%" ? "18%" : "0%"}`;
    //     const value = {
    //       baseTax: baseTax.value,
    //       serviceTax: serviceTax.value,
    //     };
        
    //     combinations.push({ label, value });
    //   });
    // });
    let basezero= taxData.filter( t => t.taxRate === 0);
    let basenonzero= taxData.filter( t => t.taxRate !==0);
    console.log("Base Zero :" ,basezero);
    basezero.sort((a,b)=> a.taxCategory.localeCompare(b.taxCategory));
    basenonzero.sort((a,b)=> a.taxCategory.localeCompare(b.taxCategory));
    let combinations = [];
      combinations.push({
          label:`Base ${basenonzero[0].taxRate}% Service ${basenonzero[1].taxRate}%`,
          value:{baseTax:basenonzero[0],serviceTax:basenonzero[1]}
      })
      combinations.push({
          label:`Base ${basezero[0].taxRate}% Service ${basezero[1].taxRate}%`,
          value:{baseTax:basezero[0],serviceTax:basezero[1]}
      })
      return combinations;

    // const base5 = taxData.find((t) => t.value.taxPercentage === "5%");
    // const base0 = taxData.find((t) => t.value.taxPercentage === "0%");
    // const service18 = taxData.find((t) => t.value.taxPercentage === "18%");
    // const service0 = taxData.find((t) => t.value.taxPercentage === "0%");
    // combinations.push({
    //   label: `Base 5% Service 18%`,
    //   value: { baseTax: base5.value, serviceTax: service18.value },
    // })
    // combinations.push({
    //   label: `Base 0% Service 0%`,
    //   value: { baseTax: base0.value, serviceTax: service0.value },
    // })

    // return combinations;
  }

  function findOption(baseTaxId, serviceTaxId) {
    return combinedTax.find((item) => {
      return (
        item.value.baseTax.id === baseTaxId &&
        item.value.serviceTax.id === serviceTaxId
      );
    });
  }

  return (
    <div>
      <Form onSubmit={handleSubmit(onFormSubmit)}>
        <Row>
          {/* <FormGroup
            className="col-lg-3"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              className={
                mix_background_layout == "dark-only"
                  ? "checkbox-dark p-0"
                  : "checkbox p-0"
              }
              style={{ display: "flex", alignItems: "center" }}
            >
              <Input
                id="isMegaCabsCompany"
                type="checkbox"
                checked={isMegaCabsCompanyField.value}
                onChange={(value) => isMegaCabsCompanyField.onChange(value)}
              />
              <Label className="mb-0" for="isMegaCabsCompany">
                {"Is MegaCabs Company"}
              </Label>
            </div>
          </FormGroup> */}
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Company Name</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                {...register("companyName", {
                  required: {
                    value: true,
                    message: "Company Name is required",
                  },
                  onChange: (e) => {
                    setValue("companyName", e.target.value.trimStart());
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.companyName?.message}
              </span>
            </Col>
          </FormGroup>
          {/* <FormGroup
            className="col-lg-3"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              className={
                mix_background_layout == "dark-only"
                  ? "checkbox-dark p-0"
                  : "checkbox p-0"
              }
              style={{ display: "flex", alignItems: "center" }}
            >
              <Input
                id="isWalletEnabled"
                type="checkbox"
                checked={isWalletEnabledField.value}
                onChange={(value) => isWalletEnabledField.onChange(value)}
              />
              <Label className="mb-0" for="isWalletEnabled">
                {"Wallet Enabled"}
              </Label>
            </div>
          </FormGroup> */}
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Service City</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={
                    serviceCityField?.value?.id
                      ? cityData.find((element) => {
                          return (
                            element?.value?.id === serviceCityField?.value?.id
                          );
                        })
                      : ""
                  }
                  isDisabled={corporateClientObj?.id ? true : false}
                  // defaultValue={cityData.find((element) => {
                  //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                  //   return element?.value?.id === cityField?.value?.id;
                  // })}
                  onChange={handleServiceCitySelectChange}
                  placeholder="Select City"
                  options={cityData}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.serviceCity?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Contact Person</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                {...register("contactPerson", {
                  required: {
                    value: true,
                    message: "Contact Person is required",
                  },
                  onChange: (e) => {
                    setValue("contactPerson", e.target.value.trimStart());
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.contactPerson?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Mobile Number</Label>
            <Col lg="12">
              <input
                type="text"
                className="form-control"
                maxLength={10}
                value={mobileField.value}
                pattern="[0-9]+"
                onChange={(e) => {
                  mobileField.onChange(e.target.value.replace(/[^0-9]/g, ""));
                }}
              />
              <span style={{ color: "red" }}>{errors?.mobile?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Email</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                {...register("email", {
                  onChange: (e) => {
                    setValue("email", e.target.value.trimStart());
                  },
                  required: {
                    value: true,
                    message: "Email is required",
                  },
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "Please enter a valid email !",
                  },
                })}
              />
              <span style={{ color: "red" }}>{errors?.email?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Address</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                {...register("addressLine", {
                  required: {
                    value: true,
                    message: "Address is required",
                  },
                  onChange: (e) => {
                    setValue("addressLine", e.target.value.trimStart());
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.addressLine?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">City</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                {...register("city", {
                  required: {
                    value: true,
                    message: "City is required",
                  },
                  onChange: (e) => {
                    setValue("city", e.target.value.trimStart());
                  },
                })}
              />
              <span style={{ color: "red" }}>{errors?.city?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">State</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                {...register("state", {
                  required: {
                    value: true,
                    message: "State is required",
                  },
                  onChange: (e) => {
                    setValue("state", e.target.value.trimStart());
                  },
                })}
              />
              <span style={{ color: "red" }}>{errors?.state?.message}</span>
            </Col>
          </FormGroup>
          {/* <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Base Fare Tax</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={
                    baseFareTaxField?.value?.id
                      ? taxData.find((element) => {
                          return (
                            element?.value?.id === baseFareTaxField?.value?.id
                          );
                        })
                      : ""
                  }
                  // defaultValue={cityData.find((element) => {
                  //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                  //   return element?.value?.id === cityField?.value?.id;
                  // })}
                  onChange={handleBaseFareTax}
                  placeholder="Select Base Fare Tax"
                  options={taxData}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.baseFareTax?.message}
              </span>
            </Col>
          </FormGroup> */}
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Tax</Label>
            <Col lg="12">
              <div className="city-select">
                {/* <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={overallTax}
                  {...register("overallTax",{

                  })}
                   
                  onChange={(e)=>{setSelectedTax(e)
                  
                    setValue("baseFareTax",e.value.baseTax)
                    setValue("serviceTax",e.value.serviceTax)
            
                  }}
                  placeholder="Select Tax"
                  options={combinedTax}
                /> */}
                <Select
                  value={overallTax}
                  {...register("overallTax")}
                  onChange={(e) => {
                    setValue("overallTax", e);
                    setValue("baseFareTax", e.value.baseTax, {
                      shouldValidate: true,
                    });
                    setValue("serviceTax", e.value.serviceTax, {
                      shouldValidate: true,
                    });
                    showAlert("warning", "The Selected Client Tax will also apply to all linked package taxes");
                  }}
                  placeholder={"Select Tax"}
                  options={combinedTax}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.serviceTax?.message}
              </span>
            </Col>
          </FormGroup>
          {/* <FormGroup
            className="col-lg-6"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              className="m-checkbox-inline mb-0 custom-radio-ml"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="radio radio-primary">
                <Input
                  id="radioinline2"
                  type="radio"
                  name="airportClient"
                  checked={isAirportClientField.value}
                  onChange={handleAirportClientChange}
                />
                <Label className="mb-0" for="radioinline2">
                  {"Airport To City"}
                </Label>
              </div>
              <div className="radio radio-primary">
                <Input
                  id="radioinline3"
                  type="radio"
                  name="cityClient"
                  checked={c2aField.value}
                  onChange={handleCityClientChange}
                />
                <Label className="mb-0" for="radioinline3">
                  {"City To Airport"}
                </Label>
              </div>
            </div>
          </FormGroup> */}
          <FormGroup className="col-lg-6">
            <Label className="col-lg-12 col-form-label">Client Type</Label>
            <Col lg="12">
              <div
                className="m-checkbox-inline mb-0 custom-radio-ml"
                style={{ display: "flex", alignItems: "center" }}
              >
                {/* Airport → City (true) */}
                <div className="radio radio-primary">
                  <Input
                    id="radioinline2"
                    type="radio"
                    name="airportClient"
                    checked={isAirportClientField.value === true}
                    onChange={() => {
                      isAirportClientField.onChange(true);
                      setValue("a2c", true, { shouldValidate: true });
                      setValue("c2a", false, { shouldValidate: true });
                    }}
                  />
                  <Label className="mb-0" for="radioinline2">
                    Airport To City
                  </Label>
                </div>

                {/* City → Airport (false) */}
                <div className="radio radio-primary">
                  <Input
                    id="radioinline3"
                    type="radio"
                    name="airportClient"
                    checked={isAirportClientField.value === false}
                    onChange={() => {
                      isAirportClientField.onChange(false);
                      setValue("a2c", false, { shouldValidate: true });
                      setValue("c2a", true, { shouldValidate: true });
                    }}
                  />
                  <Label className="mb-0" for="radioinline3">
                    City To Airport
                  </Label>
                </div>
              </div>

              {/* Error message below radio buttons */}
              <span style={{ color: "red" }}>
                {errors?.isAirportClient?.message}
              </span>
            </Col>
          </FormGroup>
        </Row>
        <Row>
          <div
            style={{
              color: "#11BF5C",
              textDecoration: "underline",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => setIsAdvanced(!isAdvanced)}
          >
            Advanced Configurations{" "}
            {isAdvanced ? (
              <ArrowUp
                style={{ width: "15px", height: "15px", marginLeft: "5px" }}
              />
            ) : (
              <ArrowDown
                style={{ width: "15px", height: "15px", marginLeft: "5px" }}
              />
            )}
          </div>
        </Row>
        {isAdvanced ? (
          <Row>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">Pan Number</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("panNo", {
                    onChange: (e) => {
                      setValue("panNo", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>{errors?.panNo?.message}</span>
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">
                Service Tax Number
              </Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("serviceTaxNo", {
                    onChange: (e) => {
                      setValue("serviceTaxNo", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.serviceTaxNo?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">Pincode</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("pincode", {
                    // onChange: (e) => {
                    //   setValue("pincode", e.target.value.trimStart());
                    // },
                    onChange: (e) => {
                      const onlyNumbers = e.target.value.replace(/\D/g, "");
                      setValue("pincode", onlyNumbers.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>{errors?.pincode?.message}</span>
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">Fax</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("fax", {
                    onChange: (e) => {
                      setValue("fax", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>{errors?.fax?.message}</span>
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">
                Billing Address
              </Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("billingAddress", {
                    onChange: (e) => {
                      setValue("billingAddress", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.billingAddress?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">Billing City</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("billingCity", {
                    onChange: (e) => {
                      setValue("billingCity", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.billingCity?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">Billing State</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("billingState", {
                    onChange: (e) => {
                      setValue("billingState", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.billingState?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">
                Billing Pincode
              </Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("billingPincode", {
                    onChange: (e) => {
                      setValue("billingPincode", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.billingPincode?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">
                Billing Contact Person
              </Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("billingContactPerson", {
                    onChange: (e) => {
                      setValue(
                        "billingContactPerson",
                        e.target.value.trimStart()
                      );
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.billingContactPerson?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">
                Billing Contact Mobile
              </Label>
              <Col lg="12">
                <input
                  type="text"
                  className="form-control"
                  maxLength={10}
                  value={billingMobileField.value}
                  pattern="[0-9]+"
                  onChange={(e) => {
                    billingMobileField.onChange(
                      e.target.value.replace(/[^0-9]/g, "")
                    );
                  }}
                />
                <span style={{ color: "red" }}>
                  {errors?.billingContactMobile?.message}
                </span>
              </Col>
            </FormGroup>
            {/* <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">Discount Value</Label>
              <Col lg="12">
                <input
                  type="text"
                  className="form-control"
                  value={discountValueField.value}
                  pattern="[0-9]+"
                  onChange={(e) => {
                    discountValueField.onChange(
                      e.target.value.replace(/[^0-9]/g, "")
                    );
                  }}
                />
                <span style={{ color: "red" }}>
                  {errors?.discountValue?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">Discount Type</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("discountType", {
                    onChange: (e) => {
                      setValue("discountType", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.discountType?.message}
                </span>
              </Col>
            </FormGroup> */}
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">Airport Charge</Label>
              <Col lg="12">
                <input
                  type="text"
                  className="form-control"
                  value={airportChargeField.value}
                  pattern="[0-9]+"
                  onChange={(e) => {
                    airportChargeField.onChange(
                      e.target.value.replace(/[^0-9]/g, "")
                    );
                  }}
                />
                <span style={{ color: "red" }}>
                  {errors?.airportCharge?.message}
                </span>
              </Col>
            </FormGroup>
          </Row>
        ) : null}

        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            type="submit"
            className="btn submit-button"
            disabled={isSubmitting}
          >
            {corporateClientObj?.id ? "Update" : "Next"}
          </button>
        </div>
      </Form>

      {/* {editId?<div style={{display:"flex",alignItems:"center",justifyContent:"end"}}><button className="btn submit-button">Next</button></div>:null} */}
    </div>
  );
}

export default CorprateForms;
